<div class="quotes-blocks" *ngIf="!quotesLoading">
  <div class="quote-block" *ngFor="let activityQuote of activityQuotes; let i = index">
    <div class="group-name">
      {{activityQuote.addressee.name}}
    </div>

    <div class="input-side">
      <p-inputNumber #awardInput class="award-input" [(ngModel)]="activityQuote.price" mode="currency" [min]="0"
                     currency="USD" locale="en-US" [minFractionDigits]="2" placeholder="Award"
                     [disabled]="!!activityQuote.awardSent" (onInput)="saveAward(activityQuote, $event)"
                     (click)="onInputClick(awardInput, i)">
      </p-inputNumber>
    </div>

    <div class="request-side">
      <button mat-button class="request-button" (click)="requestEmail(activityQuote)"
              [ngClass]="{'awarded-button': activityQuote.awardSent}">
        <ng-container *ngIf="activityQuote.awardSent">Awarded</ng-container>
        <ng-container
          *ngIf="(activityQuote.price > 0 && !activityQuote.awardSent) || (!activityQuote.awardSent && activityQuote.sentDate)">
          Award Project
        </ng-container>
        <ng-container *ngIf="(activityQuote.price === 0 || !activityQuote.price) && !activityQuote.sentDate">Send
          Quote
        </ng-container>
      </button>
    </div>
  </div>
</div>

<div class="quotes-blocks loading-quote" *ngIf="quotesLoading">
  <lib-progress-spinner></lib-progress-spinner>
</div>
